import { AlertTriangle, Check, XCircle } from "lucide-react"

import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"

// The striped variants carry an icon so state is never colour-alone — the same
// reason the order cards pair a stripe with chip text (WCAG 1.4.1).
const VARIANT_ICONS = {
  success: { Icon: Check, className: "text-success" },
  warning: { Icon: AlertTriangle, className: "text-warning" },
  error: { Icon: XCircle, className: "text-error" },
}

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        const icon = VARIANT_ICONS[props.variant]

        return (
          <Toast key={id} {...props}>
            <div className="flex items-start gap-3">
              {icon && (
                <icon.Icon
                  className={`mt-0.5 h-5 w-5 shrink-0 ${icon.className}`}
                  aria-hidden="true"
                />
              )}
              <div className="grid gap-1">
                {title && <ToastTitle>{title}</ToastTitle>}
                {description && (
                  <ToastDescription>{description}</ToastDescription>
                )}
              </div>
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
